import ru from './ru.js';

export default { ru };
